/* eslint-disable */
export default {
  to: '至',
  enterNameOrNumber: '输入姓名或号码',
} as const;

// @key: @#@"to"@#@ @source: @#@"To"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter name or number"@#@
